var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticsIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3619 28.4821V25.3592C35.0317 25.3581 35.6737 25.0903 36.1473 24.6143C36.6209 24.1384 36.8874 23.4932 36.8885 22.8201V3.12691H3.10753V22.8201C3.10858 23.4932 3.37512 24.1384 3.84872 24.6143C4.32232 25.0903 4.96436 25.3581 5.63414 25.3592V28.4821C4.1402 28.4811 2.70774 27.8842 1.65136 26.8226C0.594987 25.761 0.00105393 24.3214 0 22.8201V0H39.996V22.8201C39.995 24.3214 39.401 25.761 38.3447 26.8226C37.2883 27.8842 35.8558 28.4811 34.3619 28.4821Z",
    fill: "#C53036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9195 18.5098H8.96045V30.2177H12.9195V18.5098Z",
    fill: "#C53036"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9119 12.8276H14.9529V30.2176H18.9119V12.8276Z",
    fill: "#C53036"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.908 15.099H20.949V30.2178H24.908V15.099Z",
    fill: "#C53036"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9041 8.05334H26.9451V30.2177H30.9041V8.05334Z",
    fill: "#C53036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIconActive);
export default __webpack_public_path__ + "static/media/statistics-icon_active.8984cd781a484468c8ad2b987820535d.svg";
export { ForwardRef as ReactComponent };